module.exports = __webpack_public_path__ + "img/banamex.7d6ba7f.png";